<template>
  <div class="visualisation-date-wrapper d-flex">
    <span class="mr-1 d-inline-block" :style="width ? width : 'width: 75px;'">{{dateStr | dateFilter}}</span>
    <v-progress-circular v-if="isCircle" :value="circleOptions.value" :color="circleOptions.color" size="20" width="3"></v-progress-circular>
  </div>
</template>

<script>
    import moment from 'moment'
    import formatDates from '../constatns/formatDates'

  export default {
    props: ['date', 'isOverDue', 'interval', 'showCircle', 'width'],
    data: () => ({
      value: 70
    }),
    computed: {
      isCircle () {
        return typeof this.showCircle === 'boolean' ? this.showCircle : true
      },
      circleOptions () {
        if (this.isOverDue) {
          return {
            color: 'rgb(238,87, 40)',
            value: 100
          }
        }
        let value = 0
        let redAddition = 70
        const today = new Date()
        const targetDay = today.getDate()
        const tomorrowDay = targetDay + 1
        const dateStrToday = +moment(this.dateStr).format(formatDates.date).split('/')[0]
        if (dateStrToday === targetDay) {
          const startHour = 8
          const endHour = 22
          const workHoursInDay = endHour - startHour
          const hoursLeft = endHour - today.getHours()
          value = 100 - parseInt(hoursLeft / workHoursInDay * 100)
        } else if (dateStrToday === tomorrowDay) {
          value = 45
        } else {
          value = 0
        }
        if (this.interval === 'Daily') {
        } else if (this.interval === 'Weekly') {
          const todayDay = today.getDay()
          if (todayDay) {
            value = parseInt(todayDay / 7 * 100)
          } else {
            value = 7
          }
        } else if (this.interval === 'Monthly') {
          const dueDateDay = new Date(this.dateStr).getDate()
          const todayDay = today.getDate()
          if (todayDay) {
            value = parseInt(todayDay / dueDateDay * 100)
          } else {
            value = 7
          }
        }
        redAddition += parseInt(255 * (value / 100))
        return {
          color: `rgb(${redAddition},220, 0)`,
          value
        }
      },
      dateStr () {
        if (!this.date) { return '' }
        const dueDateInUTC = moment.utc(this.date).format(formatDates.defaultDate)
        const dateWordPointer = Date.getDateWordPointer(this.date)
        if (dateWordPointer) {
          return dateWordPointer
        } else {
          return dueDateInUTC
        }
      }
    },
    filters: {
      dateFilter (dateIsoStr) {
        if (!dateIsoStr) return
        return moment(dateIsoStr).format(formatDates.date)
      }
    }
  }
</script>
